module.exports = __webpack_public_path__ + "img/BatamPpvcFactory.c69b40fe.jpg";